import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../models/types';

interface EmrJobDashboardVars {
  appId: string;
  flintCell: string;
  jobId: string;
}

const GQL_FETCH_EMR_JOB_DASHBOARD = gql`
  query fetchEmrJobDashboard($appId: String!, $flintCell: String!, $jobId: String!, $piezoArtifacts: JSON) {
    fetchEmrJobDashboard(appId: $appId, flintCell: $flintCell, jobId: $jobId, piezoArtifacts: $piezoArtifacts)
  }
`;

export const useEmrJobDashboardQuery = () => {
  return useLazyQuery<AnyObject, EmrJobDashboardVars>(GQL_FETCH_EMR_JOB_DASHBOARD, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};
